<template>
	<div class="database-info">
		<section class="database-info__header">
		<!-- 	<el-link icon="el-icon-back" type="text" :underline="false" @click="onBack">返回</el-link>
			<el-divider direction="vertical"></el-divider> -->
			<span class="title">【{{$route.query.name}}】数据详情</span>
		</section>
		<section class="database-info__container">
			<table-pagination
			   v-loading="loading"
			   pagination
			   :data="list"
			   :column="column"
			   :total="total"
			   :page.sync="listQuery.pageNumber"
			   :limit.sync="listQuery.pageSize"
			    @pagination="getList"/>
		</section>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading:false,
				list: [],
				column:[],
				originColumn:[
					{
					    label: '序号',
					    width: 80,
					    render: (h, scope) => {
					        return <span>{((this.listQuery.pageNumber - 1) * this.listQuery.pageSize) + (scope.$index + 1)}</span>
					    }
					},
					{
						label: '操作',
						prop: 'cation',
						align: 'center',
						width: 180,
						fixed: 'right',
						render: (h, scope) => {
							return (
								<div>
									<el-link onClick={() => this.handleDelete(scope.row)} type="danger" disabled={scope.row.task_created == '1'}>删除</el-link>
								</div>
							)
						}
					},
				],
				total:0,
				listQuery: {
					pageNumber:1,
					pageSize:10,
					brandIdentify:'',
					batchNum:''
				}
				
			}
		},
		methods: {
			getList() {
				this.loading = true;
				this.$api.getBreathdataBaseInfoList(this.listQuery).then(res => {
					this.loading = false;
					if(res.errcode != 0) return;
					this.list = res.data;
					this.total = Number(res.total);
				}).catch(err => {
					this.loading = false;
				})
			},
			getColumn(){
				this.$api.getBreathdataBaseColumnList({
					batchNum:this.listQuery.batchNum,
					brandIdentify:this.listQuery.brandIdentify
				}).then(res => {
					if(res.errcode != 0) return;
					let results = [];
					for(let item of res.data){
						results.push({
							label:item.originalColumnName,
							prop:item.originalColumnCode
						})
					}
					this.column = this.originColumn.concat(results)
				})
			},
			handleDelete(row){
				this.$confirm('删除后将无法恢复, 是否继续?', '系统提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.deleteBreathdataBaseInfoList({
						brandIdentify: this.listQuery.brandIdentify,
						batchNum:row.batch_num,
						originalId: row.original_id
					}).then(res => {
						if(res.errcode != 0) return;
						this.$notify({
							title: "删除成功",
							type: "success"
						});
						this.getList();
					})
				}).catch(() => {});
				
			},
			onBack(){
				this.$router.go(-1)
			},
		},
		mounted(){
			this.listQuery.batchNum = this.$route.params.id;
			this.listQuery.brandIdentify = this.$store.getters.userInfo.brandIdentify;
			this.getColumn();
			this.getList();
		}
	}
</script>

<style lang="scss" scoped>
	.database-info {
		width: 100%;
		height: 100%;
		overflow: hidden;
		padding: 5px 10px;
		&__header {
			width: 100%;
			height: 40px;
			line-height: 40px;
			padding: 0 5px;
			
			& .el-link {
				vertical-align: top;
				color: #303133;
			}
			
			& .el-divider {
				vertical-align: top;
				margin-top: 13px;
			}
			
			& > .title {
				font-size: 14px;
				font-weight: bold;
				color: #303133;
				vertical-align: top;
				letter-spacing: .5px;
			}
		}
			
		&__container {
			width: 100%;
			height: calc(100% - 40px);
			overflow: auto;
		}
	}
</style>
